import { render } from "./RdrsMap.vue?vue&type=template&id=564dcc74"
import script from "./RdrsMap.vue?vue&type=script&lang=js"
export * from "./RdrsMap.vue?vue&type=script&lang=js"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__